<h1 mat-dialog-title>{{ data.title }}</h1>
<mat-dialog-content>
	<p [innerHTML]="data.content"></p>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button type="button" class="btn btn--tertiary btn--tertiary-wider" (click)="onCancel()">Cancel</button>
	<button type="button" class="btn btn--primary btn--primary-wider" (click)="onConfirm()">Confirm</button>
</mat-dialog-actions>
